import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Generic confirm dialog. Resolves `true` on confirm, dismisses otherwise:
 *   const ref = modal.open(ConfirmationModal); Object.assign(ref.componentInstance, {...});
 *   if (await ref.result.catch(() => false)) { ... }
 */
@Component({
  selector: 'app-confirmation-modal',
  template: `
    <div class="modal-body text-center p-4">
      <div class="confirm-icon confirm-icon--{{ variant }}" aria-hidden="true"><i class="fa-solid {{ icon }}"></i></div>
      <h5 class="mb-2">{{ title }}</h5>
      <p class="text-body-secondary mb-0">{{ message }}</p>
    </div>
    <div class="modal-footer border-0 pt-0 justify-content-center gap-2">
      <button type="button" class="btn btn-light border" (click)="active.dismiss()">{{ cancelText }}</button>
      <button type="button" class="btn btn-{{ variant }}" (click)="active.close(true)" ngbAutofocus>{{ confirmText }}</button>
    </div>
  `,
  styles: `
    .confirm-icon {
      width: 56px;
      height: 56px;
      margin: 0 auto 1rem;
      display: grid;
      place-items: center;
      border-radius: 50%;
      font-size: 1.35rem;
    }
    .confirm-icon--danger { background: var(--bs-danger-bg-subtle); color: var(--bs-danger); }
    .confirm-icon--primary { background: var(--bs-primary-bg-subtle); color: var(--bs-primary); }
    .confirm-icon--warning { background: var(--bs-warning-bg-subtle); color: var(--bs-warning-text-emphasis); }
  `,
})
export class ConfirmationModal {
  protected readonly active = inject(NgbActiveModal);

  @Input() title = 'Are you sure?';
  @Input() message = '';
  @Input() confirmText = 'Confirm';
  @Input() cancelText = 'Cancel';
  @Input() icon = 'fa-circle-question';
  @Input() variant: 'danger' | 'primary' | 'warning' = 'primary';
}
